module.exports = __webpack_public_path__ + "a16df4c1f67b42fd429f021139169c92.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/13d_activist_fund.png
// module id = 1602
// module chunks = 0